import { Block } from '@cdab/scania/qpr/components/atoms'
import { TdsIcon } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledIconEditDeviation = styled(TdsIcon)`
  cursor: pointer;
  width: 16px;
  height: 16px;
  color: black;
  margin-left: 4px;
`
export const StyledEditIconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
`

export const EmptyScreenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 100%;
`

export const TitleFilesList = styled.h4.attrs({
  className: 'tds-headline-04 tds-u-mb3'
})`
  margin: 0;
`

export const StyledBlock = styled(Block)`
  display: flex;
  flex-direction: column;
`
export const FormRow = styled.div.attrs({
  className: 'tds-u-mb1 tds-u-w-100'
})``
